import styled from "styled-components";
import { themeTypes } from "../../styled/Theme";

export const StyledAppleMatchBroadcaster = styled.div`
    font-family: 'MLSTifo';
    font-size: ${(props) => props.theme.mixins.pxToRem(11)};
    color: ${(props) => (props.theme.type == themeTypes.light ? "#868686" : "#FFF")};
    line-height: 16px;
    font-weight: 500;
    max-width: ${(props) => props.theme.figma.base.scale_5}px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0;
`;